// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__17YT8","subheader":"ReorderModal_subheader__gCmzJ","listWrap":"ReorderModal_listWrap__278Ee"};